export default {
  root: {},
  title: {
    flexGrow: 1,
  },
};
